// noinspection JSValidateTypes

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';

const Component = ({label, to}) => {
    return <Chip label={label} color="primary" component={Link} to={to}/>;
};

Component.propTypes = {
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
};

export default Component;
